import { Component, OnInit} from '@angular/core';
// import { ChartType } from 'chart.js';
// import { MultiDataSet, Label } from 'ng2-charts';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  // public doughnutChartLabels = ['Sales Q1', 'Sales Q2', 'Sales Q3', 'Sales Q4'];
  // public doughnutChartData = [120, 150, 180, 90];
  // public doughnutChartType = 'doughnut';

  // // Doughnut
  // public doughnutChartLabels: Label[] = ['Download Sales', 'In-Store Sales', 'Mail-Order Sales'];
  // public doughnutChartData: MultiDataSet = [
  //   [350, 450, 100],
  //   [50, 150, 120],
  //   [250, 130, 70],
  // ];
  // public doughnutChartType: ChartType = 'doughnut';

//   DoughnutCtrl: any[] = [  
//     {value: 300,
//       color:'#F7464A',
//       highlight: '#FF5A5E',
//       label: 'Red'},  
//     {value: 50,
//       color:'#F7464A',
//       highlight: '#FF5A5E',
//       label: 'Red'},  
//     {value: 100,
//       color:'#F7464A',
//       highlight: '#FF5A5E',
//       label: 'Gr'}  
//  ];  

  // DoughnutCtrl: string[] = [
  //   {
  //   value: 300,
  //   color:'#F7464A',
  //   highlight: '#FF5A5E',
  //   label: 'Red'
  // }]; 

//  DoughnutCtrl{data = }: [

//     {
//       value: 300,
//       color:"#F7464A",
//       highlight: "#FF5A5E",
//       label: "Red"
//     },
//     {
//       value: 50,
//                 color: "#46BFBD",
//                 highlight: "#5AD3D1",
//                 label: "Green"
//     },
//     {
//       value: 100,
//       color: "#FDB45C",
//       highlight: "#FFC870",
//       label: "Yellow"
//     }];


  constructor() { }
  

  ngOnInit(): void {
 
  }
  // public chartClicked({ event, active }: { event: MouseEvent, active: {}[] }): void {
  //   console.log(event, active);
  // }

  // public chartHovered({ event, active }: { event: MouseEvent, active: {}[] }): void {
  //   console.log(event, active);
  // }

}
